export default __webpack_public_path__ + "static/media/avatar_4.e3fe3f43.png";